import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "document-row" }
const _hoisted_4 = { class: "document-name" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.showTitle && $setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Documents"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.documents, (document) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "document-icon" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.getDocumentName(document.fileName)), 1),
        _createElementVNode("a", {
          class: "button download",
          onClick: ($event: any) => ($setup.openPdf(document.link))
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "button-text" }, "Download", -1)
        ]))], 8, _hoisted_5)
      ]))
    }), 256))
  ]))
}